// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UxvA","toggle":"styles_toggle__KjCSC","preview":"styles_preview__20O6W"};